<template>
    <div id="submitted">
      <form>
        <ol class="questions">
          <li>
            <fieldset>
              <legend>
                <div class="alert alert-success" role="alert">
                  <h2 id="submittedTitle"><i class="fa fa-check-circle"></i>Thank you, we have received your application</h2>                  
                  <p>Please ensure that you will pay the application fee.</p>
                </div>
              </legend>
            </fieldset>
          </li>
        </ol>
        </form>
    </div>
</template>

<script>

export default {
  name: 'Submitted',
  props: { 
      resetEnquiry: Function      
  },
  methods: {
    resetForm: function() {
      this.$emit('resetEnquiry');
    }
  }
}
</script>
  
<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>